import { validateEmail } from '@jusbrasil-web/shared-utils-validators'

import { ERROR_MESSAGES } from './errorMessages'

export function getEmailErrorMessage(email: string): string | undefined {
  if (!email || !validateEmail(email)) {
    return ERROR_MESSAGES.login.email.validation.invalid
  }
  return undefined
}

export function getPasswordErrorMessage(password: string): string | undefined {
  if (!password) {
    return ERROR_MESSAGES.login.password.validation.empty
  }
  return undefined
}
